import { render, staticRenderFns } from "./rolecollapse.vue?vue&type=template&id=4b431d31&ref=rolecollapse&"
import script from "./rolecollapse.vue?vue&type=script&lang=js&"
export * from "./rolecollapse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports